import { render, staticRenderFns } from "./ColdChart.vue?vue&type=template&id=e95f1288&scoped=true"
import script from "./ColdChart.vue?vue&type=script&lang=js"
export * from "./ColdChart.vue?vue&type=script&lang=js"
import style0 from "./ColdChart.vue?vue&type=style&index=0&id=e95f1288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95f1288",
  null
  
)

export default component.exports